import { render, staticRenderFns } from "./GlobalPagination.vue?vue&type=template&id=717c41b8&scoped=true&"
import script from "./GlobalPagination.vue?vue&type=script&lang=ts&"
export * from "./GlobalPagination.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalPagination.vue?vue&type=style&index=0&id=717c41b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717c41b8",
  null
  
)

export default component.exports